import { caseStatus } from 'queries/cases/types';
import { useCaseContext } from '../../Cases.context';
import { pageEnum } from 'components';
import { useTranslation } from 'react-i18next';
import { MULTIVALUE_MODE } from 'hooks/useFilters/useFilters';
import './OpenClosedCases.scss';
import { useState } from 'react';

const closedValues = [caseStatus.canceled, caseStatus.closed];
const openValues = [caseStatus.diagnosis, caseStatus.actions, caseStatus.feedback];

const filterOptions = {
  closed: closedValues,
  open: openValues,
};

const filterEnum = {
  open: 'open',
  closed: 'closed',
} as const;

type FilterEnum = keyof typeof filterEnum;

export const OpenClosedCases = () => {
  const { t } = useTranslation();
  const [active, setActive] = useState<FilterEnum>(filterEnum.open);

  const { dataToCount, onChangeFilters } = useCaseContext();
  const page = pageEnum.cases;

  const dataCount = dataToCount('status').reduce(
    (acc, { status }) => {
      if (status === caseStatus.canceled || status === caseStatus.closed) {
        acc.closed += 1;
      } else {
        acc.open += 1;
      }
      return acc;
    },
    { open: 0, closed: 0 } as Record<string, number>,
  );

  const onClick = (status: FilterEnum) => {
    setActive(status === active ? filterEnum[status] : status);

    const filterValue = filterOptions[status] || openValues;

    onChangeFilters({
      filterName: 'status',
      filterValue,
      multivalueMode: MULTIVALUE_MODE.REPLACE_PREVIOUS,
    });
  };

  return (
    <section className="open-closed-cases-container">
      <div className="status-box">
        <div className="box-items">
          {(Object.keys(dataCount) as Array<FilterEnum>).map((name) => {
            const isActive = name === active;
            const label = t(`${page}:status_count_panel.status.status.${name.toUpperCase()}`);

            return (
              <div
                className={`box-item ${isActive ? 'box-item-active' : ''}`}
                key={name}
                role="button"
                onClick={() => onClick(name)}
              >
                {`${label}: ${dataCount[name]}`}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
